// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.compact.offline.enabled .thumb[data-v-420dc3ab]::after {\n\tfont-size: 14px;\n\tcolor: var(--c-dark-5);\n\tcontent: \"Waiting for stream\";\n\ttext-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
